import React from 'react';
import './Navbar.css';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';

const Navbar = () => {
    const { cartCount } = useCart();
    return (
        <div className="navbar">
            <a href="/game/">Game</a>
            <Link to="/show-all-products">Products</Link>
            <Link to="/cart">Cart {cartCount > 0 && `(${cartCount})`}</Link>
            <Link to="/show-one-product">Get Product By Id</Link>
            <Link to="/add-new-product">Add New Product</Link>
            <Link to="/delete-one-product">Delete Product</Link>
            <Link to="/update-product">Update Product </Link>
        </div>
    );
};

export default Navbar;
